import { useTranslation } from 'react-i18next'
import { FormInput } from '@microservices/wiskey-react-components'
import { Delete } from '@mui/icons-material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  IconButton,
  Typography,
} from '@mui/material'

import { useAction } from '@pages/WindowsCreateOrEdit/components/Action/hooks/useAction'
import { Events } from '@pages/WindowsCreateOrEdit/components/Event'

import { PageContentLayout } from '@layouts/PageContentLayout'

import { GENERATOR_INPUT_TYPE } from '@constants'

type ActionProps = {
  sectionIndex: number
  tabIndex: number
  actionIndex: number
  removeAction?: (index: number) => void
}

export const Action = ({ removeAction, sectionIndex, tabIndex, actionIndex = 0 }: ActionProps) => {
  const { t } = useTranslation()
  const { data } = useAction({ sectionIndex, tabIndex, actionIndex })
  const { watchActionTitle, actionOptions } = data

  const defaultLabelActionText = `${t('window.action.label')} ${actionIndex + 1}`
  const labelActionText = watchActionTitle?.label
    ? `${defaultLabelActionText} | ${watchActionTitle?.label}`
    : defaultLabelActionText

  return (
    <PageContentLayout sx={{ p: 1, backgroundColor: theme => theme.palette.grey['200'] }}>
      <Accordion sx={{ backgroundColor: theme => theme.palette.grey['200'] }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{
            my: 0,
            minHeight: '48px !important',
            '& .MuiAccordionSummary-content': {
              m: '0px !important',
            },
          }}
        >
          <Typography alignSelf={'center'} flexGrow={1}>
            {labelActionText}
          </Typography>
          <IconButton
            onClick={() => {
              if (removeAction) {
                removeAction(actionIndex)
              }
            }}
          >
            <Delete />
          </IconButton>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ p: 1, backgroundColor: theme => theme.palette.grey['200'] }}>
            <Grid display='flex' justifyContent={'space-between'}>
              <FormInput
                disableClearable
                autocompleteOptions={actionOptions}
                inputType={GENERATOR_INPUT_TYPE.AUTOCOMPLETE}
                label={`${t('window.action.label')} ${actionIndex + 1}`}
                name={`sections.${sectionIndex}.tabs.${tabIndex}.actions.${actionIndex}.actionTitle`}
                placeholder={t('window.action.placeholder')}
                sx={{ width: '100%' }}
                value={watchActionTitle}
                rules={{
                  required: true,
                }}
              />
            </Grid>

            <Events actionIndex={actionIndex} sectionIndex={sectionIndex} tabIndex={tabIndex} />
          </Box>
        </AccordionDetails>
      </Accordion>
    </PageContentLayout>
  )
}
